import React, { lazy } from 'react';

import env from 'helpers/env';

import SuspenseWrapper from './SuspenseWrapper';

const SchedulerRoutes = lazy(() => import('./scheduler'));
const ConsentRoutes = lazy(() => import('./consent'));
const AppRoutes = lazy(() => import('./app'));

const Routes = () => {
  const currentHostname = window.location.hostname;
  const schedulerUrl = new URL(env.avomaSchedulerUrl);
  const consentUrl = env?.avomaConsentUrl ? new URL(env.avomaConsentUrl) : null;
  const isSchedulerHost = schedulerUrl.hostname === currentHostname;
  const isConsentHost = consentUrl?.hostname === currentHostname;

  if (isSchedulerHost)
    return (
      <SuspenseWrapper>
        <SchedulerRoutes />
      </SuspenseWrapper>
    );

  if (isConsentHost)
    return (
      <SuspenseWrapper>
        <ConsentRoutes />
      </SuspenseWrapper>
    );

  return (
    <SuspenseWrapper>
      <AppRoutes />
    </SuspenseWrapper>
  );
};

export default Routes;
